<template>
  <div :style="{'margin-top': bottomTable}">
    <div class="scroll-top" />
    <div v-if="tableData.row.length">
      <span v-if="isFuture" class="mk-current__table mk-future__title">{{ $t('mc.pageTitles.futureMc') }}</span>
      <base-table
        :head="tableData.head"
        :columnTemplates="tableData.sizeColumn"
      >
        <base-table-row
          v-for="(element) of MkWithSubArrays[page - 1]" :key="`${element.mcId}supervisor-table-row`"
          :columnTemplates="tableData.sizeColumn"
        >
          <base-table-column class="table-column_elipsis">
            <Copy :text="element.amoId" :textMessage="$t('mc.toasts.copyLink')" />
            <a :href="element.amoId" target="blank">{{ element.amoIdOnlyId }}</a>
          </base-table-column>
          <base-table-column>
            <router-link
              :to="`/master-classes/detail/${element.mcId}`" target="_blank" v-tooltip="$t('mc.tooltips.detailMc')"
            >
              <inline-svg
                class="icon-in-mk"
                :src="require(`@/assets/svg/link.svg`)"
              />
            </router-link>
          </base-table-column>
          <base-table-column>
            <div>
              <span>{{ element.date.start }}</span>
              <br />
              <span>{{ element.date.hour }}</span>
            </div>
          </base-table-column>
          <base-table-column>
            <a
              v-if="element.buttons.haveMimk"
              href="javascript:void(0)"
              @click="callModal('changeMimk', element)"
            >
              <span v-tooltip="getMimkTags(element.mimkId)">{{ element.mimk }}</span>
            </a>
            <a
              v-else
              href="javascript:void(0)"
              @click="callModal('giveMimk', element)"
            >
              {{ $t('mc.supervisor.buttons.addMimk') }}
            </a>
          </base-table-column>
          <base-table-column>
            {{ element.kid_name }}<span
            v-if="element.kid_age"
          >,<br>{{ `${element.kid_age} ${$t('mc.detailsMc.years')}` }}</span>
          </base-table-column>
          <base-table-column>
            <div class="cell-content__status">
              <inline-svg
                v-if="element.status.status && element.status.svgName"
                :src="require(`@/assets/svg/${element.status.svgName}.svg`)"
                class="cell-content__status-icon"
              />
              <span>
                  {{ element.status_translated }}
                  <br>
                  <span
                    v-if="element.hour_before_confirmed"
                    class="table-column-status_hour-confirm"
                  >{{ $t('mc.tables.cols.confirmBeforeHour') }}
                  </span>
                </span>
            </div>
          </base-table-column>
          <base-table-column v-if="zoomActive">
            <div class="zoom-links-wrapper" v-if="element.zoom_start_url || element.zoom_join_url">
              <a
                v-if="element.zoom_start_url && !isZoomButtonActive(element)"
                href="javascript:void(0)"
                class="zoom-start-link zoom-start-link--disabled"
                v-tooltip="zoomStartUrlTooltip(element)"
              >
                <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
              </a>
              <a
                v-else-if="element.zoom_start_url"
                :href="element.zoom_start_url"
                class="zoom-start-link"
                target="_blank"
                v-tooltip="zoomStartUrlTooltip(element)"
              >
                <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
              </a>
              <a
                v-if="element.zoom_join_url"
                href="javascript:void(0)"
                @click="copyToClipboard(element.zoom_join_url)"
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.copyZoom')"
              >
                  <span>
                    <inline-svg :height="16" :src="require(`@/assets/svg/upload-icon-white.svg`)"></inline-svg>
                  </span>
              </a>
            </div>
          </base-table-column>
          <base-table-column>
            <div v-if="canUseZoomFlags">
              <span
                v-if="element.zoom_link_in_wa_sent && element.zoom_link_in_wa_sent === true"
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkWaTrue')"
              >
                <img width="40px" height="40px" :src="require(`@/assets/svg/whatsapp_actiive.svg`)" />
              </span>
              <span
                v-else
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkWaFalse')"
              >
                <img width="40px" height="40px" :src="require(`@/assets/svg/whatsapp_not_active.svg`)" />
              </span>
              <span
                v-if="element.zoom_link_in_mail_sent && element.zoom_link_in_mail_sent === true"
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkMailTrue')"
              >

                <img width="40px" height="40px" :src="require(`@/assets/svg/mail_active.svg`)" />

              </span>
              <span
                v-else
                class="zoom-join-link"
                v-tooltip="$t('mc.zoom.zoomLinkMailFalse')"
              >

                <img width="40px" height="40px" :src="require(`@/assets/svg/mail_not_active.svg`)" />

              </span>
            </div>
          </base-table-column>
          <div class="tags-wrapper" v-if="bookingsTags && Array.isArray(bookingsTags[element.mcId])">
            <Tags
              :show-title="false" :modify-ability="false" tags-wrapper-style="width: calc(100vw - 400px);"
              :prop-tags="bookingsTags[element.mcId]"
            ></Tags>
          </div>
        </base-table-row>
      </base-table>
      <div class="pagination">
        <Count @changeCountsOnPage="changeCountsOnPage" />
        <pagination
          v-model="page"
          :records="tableData.row.length"
          :per-page="perPage"
          :options="{texts: false}"
          @paginate="setPage"
        />
      </div>
    </div>
    <div class="empty-mk-title" v-if="!tableData.row.length && emptyTableTitleName">
      {{ $t('mc.supervisor.titles.currentMcNotFound') }}
    </div>
  </div>
</template>

<script>
  import scrollToContent from '@/helpers/scrollToContent'
  import { Supervisor } from '@/helpers/tableConstructor'
  import createSubarrays from '@/helpers/createSubarrays'
  import Count from '@/components/UI/CountElementsOnPage'
  import Copy from '@/components/UI/Copy'
  import Tags from '@/components/Supervisor/Tags'
  import copyToClipboard from '@/helpers/copyToClipboard';
  import { isDateTimeInRange } from '@/helpers/commonHelpers';
  import { BACKOFFICE } from '@/services/HTTPService'

  export default {
    data() {
      return {
        perPage: 10,
        page: 1,
        canUseZoomFlags: false,
        MkWithSubArrays: [],
        tableData: {
          head: [
            this.$t('mc.tables.titles.amoLink'),
            '',
            this.$t('mc.tables.titles.date'),
            this.$t('mc.tables.titles.mimk'),
            this.$t('mc.tables.cols.kid'),
            this.$t('mc.tables.titles.status'),],
          sizeColumn: '',
          row: {}
        },
      }
    },
    props: {
      zoomActive: {
        type: Boolean,
        default: false,
      },
      emptyTableTitleName: {
        type: String,
        required: true,
        default: ''
      },
      isFinished: {
        type: Boolean,
        required: false,
        default: false
      },
      isFuture: {
        type: Boolean,
        required: false,
        default: false
      },
      isCurrent: {
        type: Boolean,
        required: false,
        default: false
      },
      propsTableData: {
        type: Array,
        required: true
      },
      sizeColumn: {
        type: String,
        required: true
      }
    },
    components: {
      Copy,
      Count,
      Tags,
    },
    async mounted() {
      this.canUseZoomFlags = await this.getSegmentForZoomFlags()
    },
    async created() {
      if (!localStorage.getItem('countsOnPage')) {
        this.perPage = 10
      } else {
        this.perPage = JSON.parse(localStorage.getItem('countsOnPage')).value
      }
      if (this.zoomActive) {
        this.tableData.head.push('Zoom')
      }
      this.tableData.head.push(this.$t('mc.tables.titles.link'))
      this.tableData.sizeColumn = this.sizeColumn
      this.buildTAble(this.propsTableData)
    },
    methods: {
      isZoomButtonActive(el) {
        return isDateTimeInRange(null, el.zoom_session_starts_at, el.zoom_session_ends_at, this.$store.state.user.segment.tz_offset) &&
            (this.$store.state.user.user.id === el.mimkId || this.$store.state.user.user.role === 'supervisor' || this.$store.state.user.user.role === 'admin')
      },
      zoomStartUrlTooltip(el) {
        const isZoomButtonActive = this.isZoomButtonActive(el)

        if (isZoomButtonActive) return this.$t('mc.zoom.startZoom')

        const now = this.$dayjs(this.$dayjs(new Date()).utc().add(this.$store.state.user.segment.tz_offset, 'second').format('YYYY-MM-DD HH:mm'))
        const startDate = this.$dayjs(el.zoom_session_starts_at)

        if (now.isBefore(startDate)) return this.$t('mc.zoom.prompt2', [startDate.format('HH:mm')])

        if (el.mimkId !== this.$store.state.user.user.id && this.$store.state.user.user.role !== 'supervisor' && this.$store.state.user.user.role !== 'admin') {
          return this.$t('mc.zoom.prompt1')
        }

        return this.$t('mc.zoom.prompt3')
      },
      copyToClipboard(text) {
        copyToClipboard(text, () => {
          this.$toasted.global.all_ok(this.$t('mc.toasts.copyLink'))
        })
      },
      getMimkTags(mimkId) {
        if (this.mimksTags && this.mimksTags[mimkId]) {
          return this.mimksTags[mimkId].map(tag => tag.name).join(', ')
        }

        return null
      },
      callModal(type, TC) {
        this.$emit('callModal', {
          type,
          TC,
        })
      },
      setPage() {
        scrollToContent(this.$el.querySelector('.scroll-top'))
      },
      async changeCountsOnPage(value) {
        this.perPage = value
        this.buildTAble(this.propsTableData)
      },
      async getSegmentForZoomFlags() {
        try {
          const response = await BACKOFFICE.get(`/segments/${this.$store.state.user.segment.id}/`);
          return response.data.use_sending_zoom_links;
        } catch (e) {
          console.error(e);
          return false;
        }
      },
      buildTAble(data) {
        this.tableData.row = new Supervisor(data)
        this.MkWithSubArrays = createSubarrays(this.perPage, this.tableData.row)
      },
    },
    computed: {
      bottomTable() {
        return this.isFuture ? '30px' : 0
      },
      bookingsTags() {
        return this.$store.state.tags.bookingsTagsObject
      },
      mimksTags() {
        return this.$store.state.tags.mimksTagsObject
      },
    },
  }
</script>

